import gql from 'graphql-tag';
import { SITE_SETUP_FRAGMENT } from 'data/fragments/siteSetup';
import { FREEFOOD_SETUP_FRAGMENT } from 'data/fragments/freefoodSetup';
import { MICROSTORE_COLUMN_GROUP_SETUP_FRAGMENT } from 'data/fragments/microstoreColumnGroupSetup';

export const GET_SITE_SETUPS_FOR_DATE_QUERY = gql`
    query GET_SITE_SETUPS_FOR_DATE($date: String!) {
        getSiteSetupsForDate(date: $date) {
            _id
            createdAt
            date
            delivery {
                isDynamic
            }
            freefoodSetup {
                ...FreefoodSetupFragment
            }
            isFinishForced
            microstoreColumnGroupSetups {
                ...MicrostoreColumnGroupSetupFragment
            }
            siteId
            site {
                _id
                organizationName
                microstoreColumnGroups {
                    _id
                    name
                    columns {
                        _id
                        name
                    }
                }
                name
                state
                type
            }
            state
            stateHistory {
                createdAt
                createdBy
                createdByName
                state
            }
            updatedAt
        }
    }
    ${FREEFOOD_SETUP_FRAGMENT}
    ${MICROSTORE_COLUMN_GROUP_SETUP_FRAGMENT}
`;

export const GET_SITE_SETUP_QUERY = gql`
    query GET_SITE_SETUP($siteSetupId: ID!) {
        getSiteSetup(siteSetupId: $siteSetupId) {
            ...SiteSetupFragment
        }
    }
    ${SITE_SETUP_FRAGMENT}
`;

// The rangement's OWN delivery (fixed or dynamic), resolved through the setup's `delivery` field
// (SiteSetup.deliveryId → dataloader). Goes through getSiteSetup (MOBILE_ACCESS) so it stays available
// to the same roles as the rest of the page — unlike delivery(deliveryId) which is ADMIN_ACCESS.
// Replaces getSiteDeliveryOfDate(date, siteId), which was hard-wired to the fixed delivery.
export const GET_SITE_SETUP_DELIVERY_QUERY = gql`
    query GET_SITE_SETUP_DELIVERY($siteSetupId: ID!) {
        getSiteSetup(siteSetupId: $siteSetupId) {
            _id
            delivery {
                _id
                boxes {
                    _id
                    number
                    bundle {
                        _id
                        operatorName
                    }
                    orderId
                    products {
                        _id
                        boxId
                        quantity
                        quantityPicked
                    }
                    columnId
                }
                stockTransfersProductSummary {
                    productId
                    quantityRequested
                    quantityPositioned
                    quantityPicked
                    quantitySoldoutOnline
                    quantitySoldoutBundle
                }
            }
        }
    }
`;

export const GET_SITE_SETUPS_BY_SITE_ID_QUERY = gql`
    query GET_SITE_SETUPS_BY_SITE_ID($siteId: String!, $date: String!) {
        getSiteSetupsBySiteId(siteId: $siteId, date: $date) {
            _id
            createdAt
            date
            delivery {
                isDynamic
            }
            deliveryPerson {
                _id
                fullname
            }
            freefoodSetup {
                ...FreefoodSetupFragment
            }
            isFinishForced
            issues {
                productsIssues {
                    comment
                    productId
                    brokenDuringDeliveryQuantity
                    brokenOnSiteAfterInventoryQuantity
                    brokenOnSiteBeforeInventoryQuantity
                    expiredDeliveredQuantity
                    expiredOnSiteAfterInventoryQuantity
                    expiredOnSiteBeforeInventoryQuantity
                    notEnoughPlaceQuantity
                    otherBeforeInventoryQuantity
                    otherAfterInventoryOrDuringDeliveryQuantity
                    unexpectedOnSiteQuantity
                    wrongQuantityDelivered
                }
            }
            microstoreColumnGroupSetups {
                ...MicrostoreColumnGroupSetupFragment
            }
            siteId
            site {
                _id
                organizationName
                microstoreColumnGroups {
                    _id
                    name
                    columns {
                        _id
                        name
                    }
                }
                name
                state
                type
            }
            state
            stateHistory {
                createdAt
                createdBy
                createdByName
                state
            }
            updatedAt
        }
    }
    ${FREEFOOD_SETUP_FRAGMENT}
    ${MICROSTORE_COLUMN_GROUP_SETUP_FRAGMENT}
`;
